import script from "./Invoice.vue?vue&type=script&setup=true&lang=js"
export * from "./Invoice.vue?vue&type=script&setup=true&lang=js"

import "./Invoice.vue?vue&type=style&index=0&id=8bd4be64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bd4be64"]])

export default __exports__